<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<div class="modal-to-front" *ngIf="visible">
    <div class="hostile-takeover-overlay modal-backdrop in">
        <div class="modal-dialog {{class}}">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row">
                        <div class="col-xs-8 col-xs-offset-2" id="title">{{modalTitle}}</div>
                        <div class="col-xs-2">
                            <span class="glyphicon glyphicon-remove pull-right" (click)="hideModal();"></span>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row modal-body-section">{{message}}</div>
                    <div class="row modal-body-section">
						<ng-content></ng-content>
                    </div>
                </div>
                <div class="modal-footer" *ngIf="buttons">
                    <div class="row">
                        <div class="col-xs-12">
                            <button *ngFor="let button of buttons" type="button" class="{{button.className}}" [disabled]="button.isDisabled()" (click)="button.clickMethod()">
                                <i class="fa {{button.icon}}" *ngIf="button.icon"></i>{{button.text}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
